// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"19":"richtext","736":"vendor"}[chunkId] || chunkId) + "." + {"19":"c7b88e5f","132":"b724bf05","136":"a74958b2","147":"ca6ab2e5","247":"b4b80286","267":"aa3e2e60","416":"c3a9c2c5","482":"cd84e3b0","736":"af015859","840":"5746640c"}[chunkId] + ".chunk.js";
};